module.exports = __webpack_public_path__ + "img/souso_bg.3d10b0b6.png";